/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_REBATE_PROGRAM_EXCLUDED_CLAIMS =
  'GET_REBATE_PROGRAM_EXCLUDED_CLAIMS';
export const SET_SELECTED_INPUT_EXCLUDED_CLAIMS =
  'SET_SELECTED_INPUT_EXCLUDED_CLAIMS';
export const EXCLUDED_CLAIMS_DROP_DOWN = 'EXCLUDED_CLAIMS_DROP_DOWN';
export const EXCLUDED_CLAIMS_RESULT_GRID = 'EXCLUDED_CLAIMS_RESULT_GRID';

export const IS_LOADING_EXCLUDED_CLAIMS = 'IS_LOADING_EXCLUDED_CLAIMS';
export const REFRESH_EXCLUDED_CLAIMS = 'REFRESH_EXCLUDED_CLAIMS';
export const SET_PAGINATION_INDEX_EXCLUDED_CLAIMS =
  'SET_PAGINATION_INDEX_EXCLUDED_CLAIMS';
export const SET_NEWORK_ERROR = 'SET_NEWORK_ERROR';
export const GENERATE_PDF_DATA = 'GENERATE_PDF_DATA';
export const SET_ALL_NON_INVOICE_DATA = 'SET_ALL_NON_INVOICE_DATA'
export const SET_REBATE_PROGRAM_DATA = 'SET_REBATE_PROGRAM_DATA'